/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
    Button
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  VerticalAlignBottomOutlined,
  PlusOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
// import {
//   MenuOutlined,
//   EditOutlined,
// } from "@ant-design/icons";
export default function ApprovalRequest() {

const addModalRef = useRef(null);

  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const [vendorTypeOptions, setVendorTypeOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
   
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };

  const showModal = () => {
   addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        {/* 使用 Space 的 direction="vertical" 来让复选框垂直排列 */}
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );
  const content2 = <a>Export to CSV</a>;

  // table
  const initTableHead = {
    trust: null,
    groupCode: null,
    property: null,
    amount: null,
    otherAmount:null,
    batchNumber:null,
    glAcct:null,
    remark:null,
    usid:null,
    dateStartSt:null,
    dateEndSt:null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    // {
    //   title: "#",
    //   key: "#",
    //   dataIndex: "#",
    //   hidden: false,
    //   align: "center",
    //   width: 80,
    // },


    {
      title: "Trust",
      dataIndex: "trust",
      titleType: "Input",
      width: 130,
      onChange: (e) => tableFilterFn(e, "trust"),
    },
    // {
    //   title: "Group",
    //   dataIndex: "groupCode",
    //   titleType: "Input",
    //   width: 100,
    //   // isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, "groupCode"),
    // },

     {
      title: "Property",
      dataIndex: "property",
      titleType: "Input",
      width: 140,
      onChange: (e) => tableFilterFn(e, "property"),
    },
       {
      title: "Unit",
      dataIndex: "unit",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "unit"),
    },
    
      {
      title: "tenant",
      dataIndex: "tenant",
      titleType: "Input",
      width: 160,
      onChange: (e) => tableFilterFn(e, "tenant"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      titleType: "Input",
      width: 120,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "amount"),
    },

    {
      title: "Other Amount",
      dataIndex: "otherAmount",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "otherAmount"),
    },
    {
      title: "Batch #",
      dataIndex: "batchNumber",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "batchNumber"),
    },
    {
      title: "Gl Acct",
      dataIndex: "glAcct",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "glAcct"),
    },
      {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width:220,
      onChange: (e) => tableFilterFn(e, "remark"),
    },
    // {
    //   title: "Date",
    //   dataIndex: "date",
    //   titleType: "",
    //   width: 80,
    //   render: (text =>  text && moment(text).format("MM/DD/YYYY"))
    // },
       {
          title: "Date",
          dataIndex: "date",
          titleType: "RangePicker",
          width:120,
          onChange: (e) =>
            tableFilterFn(
              e,
              ["dateStartSt", "dateEndSt"],
              "RangePicker"
            ),
              render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
        },
         {
      title: "Usid",
      dataIndex: "usid",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "usid"),
    },
  ];


  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getGlTransList, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
            //  key: item.propId,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };



  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);


  
  useEffect(() => {
    if(vendorTypeOptions?.length && stateOptions?.length){
      setColumns(initColumns);
    }
  }, [vendorTypeOptions, stateOptions]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          {" "}
         <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
                New
              </Button>   
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
            {commonFn.btnAuthorityFlag('Download') && <Radio.Button value="c">
              <Popover content={content2} title="" trigger="click">
                <VerticalAlignBottomOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>}
          </Radio.Group>
        </div>
      </Flex>
  <CustomTable
  refreshKey={refreshKey}
  tableLoading={tableLoading}
  columns={columns.filter(c => !c.hidden)}  
  tableList={tableList}
  pagination={pagination}
  handleTableChange={handleTableChange}
  rowKey={"#"} 
  tableCss="maintenanceTable"
/>
       <AddModal ref={addModalRef}
      onSuccess={() => {
        getTableListFn(pagination.current, pagination.pageSize, tableHead);
      }}
    />
    </div>
  );
}
